import * as autobind from 'autobind';
import React, { Component } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'redux-scaffolding-ts';
import { resolve } from 'inversify-react';
import TailwindLocationEditor from '../../../../widgets/bussiness/location-editor-tw';
import TailwindInstructorEditor from '../../../../widgets/bussiness/request-instructor-editor-tw';
import { RequestWizardStore, RequestWizardData } from 'stores/requests/create-request-wizard-store';
import { nameof } from 'utils/object';
import { IdentityService } from 'services/identity-service';

interface TailwindStepInstructorsProps extends WithTranslation {
  requestWizardStore?: RequestWizardStore;
}

@connect(['requestWizardStore', RequestWizardStore])
class TailwindStepInstructors extends Component<TailwindStepInstructorsProps, any> {
  @resolve(IdentityService)
  private identityService: IdentityService;

  private get requestWizardStore() {
    return this.props.requestWizardStore;
  }

  constructor(props) {
    super(props);

    this.state = {};
  }

  @autobind
  private handleValue(property: string, value: any) {
    const change = {};
    change[property] = value;
    this.requestWizardStore.change({ ...this.requestWizardStore.state.item, ...change });
  }

  private isPlannerTFT = () => {
    const userinfo = this.identityService.getUserInfo();
    return IdentityService.isPlannerTFT(userinfo);
  };

  private isPlannerMTC = () => {
    const userinfo = this.identityService.getUserInfo();
    return IdentityService.isPlannerMTC(userinfo);
  };

  render() {
    const { t } = this.props as any;

    return (
      <>
        <div className="mb-3">
          <label className="block text-sm text-gray-700 mb-1">{t("Instructor's Location")}</label>
          <TailwindLocationEditor
            clearable
            nullable
            value={this.requestWizardStore.state.item.instructorLocation}
            onChange={location => {
              this.handleValue(nameof<RequestWizardData>('instructorLocation'), location);
              this.handleValue(nameof<RequestWizardData>('instructor'), null);
            }}
          />
        </div>

        <div className="mb-3">
          <label className="block text-sm text-gray-700 mb-1">{t("Instructor's Name")}</label>
          <TailwindInstructorEditor
            clearable
            role={'Instructor'}
            nullable
            location={this.requestWizardStore.state.item.instructorLocation}
            value={this.requestWizardStore.state.item.instructor}
            onChange={instructor => {
              this.handleValue(nameof<RequestWizardData>('instructor'), instructor);
              !instructor
                ? this.requestWizardStore.clear()
                : this.handleValue(nameof<RequestWizardData>('instructorLocation'), instructor.location);
            }}
            activeOnly={true}
            onlyInstructorsPlannerTFT={this.isPlannerTFT()}
            onlyInstructorsPlannerMTC={this.isPlannerMTC()}
          />
        </div>
      </>
    );
  }
}

export default withTranslation()(TailwindStepInstructors);
